import { ActionButton, AltButton } from '../../common/Buttons/Buttons';
import { Input } from '../../common/Forms/Input/Input';

export const GeographicStateFormPanel = ({
  editingStateId,
  register,
  errors,
  onSubmit,
  onCancel,
}) => (
  <>
    <h4 className="parameters-page__create-title">
      {editingStateId ? 'Editar estado' : 'Crear nuevo estado'}
    </h4>
    <div className="parameters-page__create-fields parameters-page__create-fields--city">
      <div
        className="row"
        style={{ width: '100%', alignItems: 'flex-start' }}
      >
        <Input
          bootstrap="col-12 col-md-3"
          label="Nombre del estado *"
          type="text"
          name="name"
          register={register}
          placeholder="Nombre del estado"
          errors={errors?.name?.message}
        />
        <div
          className="col-12 col-md-auto buttons-center-container"
          style={{ marginTop: '32px' }}
        >
          <ActionButton
            label={editingStateId ? 'Guardar cambios' : 'Guardar'}
            action={onSubmit}
          />
          <AltButton label="Cancelar" action={onCancel} />
        </div>
      </div>
    </div>
  </>
);
